<template>
  <div class="node-section-page">
    <div class="banner" @click.self="changeHandle">节点分布
      <el-button type="primary" icon="el-icon-d-arrow-left" @click="mapGoBack(mapChart)"></el-button>
    </div>
    <div class="content-wrapper-one">
      <div class="content-one container-map">
      </div>
      <div class="content-two">
        <p class="label">节点列表</p>
        <div class="inner-box">
          <div class="icon-item" v-for="(item, index) in nodeList" :key="index">
            <img class="icon" :src="themeData ? require('../assets/icon/pointicon@2x.svg') : require('../assets/icon/pointicon@2x_1.svg')" alt="">
            <div class="text-box">
              <p class="text">{{item.name}}</p>
              <!-- <p class="text">公钥:<br/>{{item.plubicKey}}</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper-two">
      <div class="content-three">
        <el-table
        height="100%"
          :data="nodeList" align="left">
          <el-table-column
            prop="name"
            label="节点名称">
          </el-table-column>
          <el-table-column
            prop="ip"
            label="ip">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
          </el-table-column>
          <el-table-column
            prop="type"
            label="节点类型" align="left">
          </el-table-column>
        </el-table>
        <!-- <div class="table-button-box">
          <el-button>Check All</el-button>
          <el-button>History</el-button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
let echarts = require('echarts/lib/echarts');
import {Eth, eth, contracts} from '../util/eth_config'
let cityGeo = require('../util/city_geo.json')
import { nodeListTest } from '../util/testData'
let mapChart

export default {
  data() {
    return {
      mapChart: '',
      nodeList: [],
      mapData: [],
      currentGeoName: '',
      preGeoNameArr: [],
      mapOption: {
        geo: {
          map: '',
          // label: {show: true},
          layoutCenter: ['50%', '50%'],
          layoutSize: '100%',
          itemStyle: {
            areaColor: '#fff'
          },
          emphasis: {
            label: {color: '#000'},
            itemStyle: {areaColor: '#2EBE4C'}
          },
        },
        series: [{
          hoverAnimation: true,
          label: {
            formatter: '{b}',
            position: 'right',
            show: true,
            lineHeight: 25,
          },
          itemStyle: {
            color: 'red'
          },
          labelLine: {
            show: true,
            length2: 10,
            lineStyle: {
              color: "red",
              width: 1,
              type: 'dotted'
            }
          },
          labelLayout: function () {
            return {
              x: mapChart.getWidth() - 200,
              moveOverlap: 'shiftY'
            };
          },
          zlevel: 2,
          type: 'effectScatter',
          coordinateSystem: 'geo',
          rippleEffect: {
            period: 4,
            scale: 4,
            brushType: 'stroke',
          },
          data: []
        }]
      }
    }
  },
  components: {},
  computed: {
    themeData() {
      return this.$attrs.themeData
    }
  },
  watch: {
    mapOption (newVal) {
      if (newVal) {
        // console.log(val.series[0].data.toString())
        this.renderMap()
      }
    }
  },
  mounted() {
    this.initChart()
    this.fechNodeList()

    // console.log($('.banner'))

    $('.banner').on('tap', function() {
            // console.log('双击');
        })
  },
  methods: {
    changeHandle() {
      let pageRoot = document.querySelector('.node-section-page')
      this.$emit('callback', pageRoot)
    },
    renderMap() {
      if(!this.mapChart) return
      this.mapChart.setOption(this.mapOption)
      this.mapChart.resize()
    },
    fetchNodeAddr () {
      this.$http()
    },
    fetchContAddress () {
      return this.$http({
        id: '',
        method: 'net_sysContract'
      })
    },
    async fechNodeList () {
      let idcertContract
      const IDCertContract = eth.contract(contracts)
      // console.log(IDCertContract)

      // 获取node账户
      let contAddress = await this.fetchContAddress()
      idcertContract = await IDCertContract.at(contAddress['DposPbft'])
      let accountList = await idcertContract.getMembers()
      accountList = accountList['0']

      // console.log(accountList)


      let nodeListSource = []
      let cityName = ['昆明市', '丽江市', '保山市', '文山州', '普洱市', '昆船', '云南省科技厅']

      // 前端暂时写死IP
      let ipArry = ['182.92.10.110', '8.136.112.41', '47.106.250.184', '47.108.219.132', '47.108.221.65', '47.106.246.157','210.72.89.19']

      for (let index = 0; index < 7; index++) {
          let nodeObj = {
            name: `${cityName[index]}节点`,
            status: '在线',
            superNode: '是',
            ip: ipArry[index],
            address: cityName[index],
            point: cityGeo[cityName[index]]
          }
          this.mapData.push({
            name: `${nodeObj.address}节点`,
            value: nodeObj.point,
            symbolSize: 10
          })
          nodeListSource.push(nodeObj)
      }

      // this.mapOption.series[0].data = this.mapData
      this.nodeList = nodeListTest
      // this.renderMap()
    },
    themeHandle(theme) {
      let color = theme === 'light' ? '#fff' : '#14142e'
      this.mapOption.geo.itemStyle.areaColor = color
      // this.renderMap()
    },
    async getGeoJson(jsonName) {
      /*PROD*/
      // return await dataVJson(jsonName);
      /*DEV*/
      return await $.get('/mainApi/dataV/' + jsonName)
      // return await $.get('https://geo.datav.aliyun.com/areas_v3/bound/' + jsonName)
    },
    initEcharts(adcode, geoJson, name, chart, alladcode) {
      let _this = this
      this.mapChart = chart
      let showData = this.callMapData(adcode)
      echarts.registerMap(name, geoJson)
      this.mapOption['geo']['map'] = name
      this.mapOption['series'][0]['data'] = showData

      // set map Option
      chart.setOption(this.mapOption)

      // unbind chart event
      chart.off('click')
      chart.off('contextmenu')

      this.currentGeoName = name
      // console.log('renderAfter-----current', this.currentGeoName)

      // add listen event for go down
      chart.on('click', params => {
        let clickRegionCode = alladcode.filter(
          areaJson => areaJson.name === params.name)[0].adcode
        let regParma
        _this.preGeoNameArr.push(_this.currentGeoName)
        // console.log(_this.preGeoNameArr, _this.currentGeoName)
        if (params['name'].endsWith('区') || params['name'].endsWith('县')) {
          regParma = clickRegionCode + '.json'
        } else {
          regParma = clickRegionCode + '_full.json'
        }
        _this.getGeoJson(regParma)
          .then(regionGeoJson => {
            _this.initEcharts(clickRegionCode, regionGeoJson, params.name, chart, alladcode)
          })
          .catch(err => {
            _this.getGeoJson('530000_full.json').then(
              YunNanGeoJson => this.initEcharts('530000', YunNanGeoJson, '云南省', chart, alladcode)
            )
          })
      })

      // add listen event for go back
      chart.on('contextmenu', params => {
        _this.mapGoBack()
      })
    },
    async mapGoBack() {
      let alladcode = await this.getGeoJson('all.json')
      if(this.preGeoNameArr.length <= 0) return

      let preGeoName = this.preGeoNameArr.pop()

      let regParma
      document.oncontextmenu = function (event) {
        event.preventDefault();
      }

      let preRegionCode = alladcode.filter(
        areaJson => areaJson.name === preGeoName)[0].adcode

      if (preGeoName.endsWith('区') || preGeoName.endsWith('县')) {
        regParma = preRegionCode + '.json'
      } else {
        regParma = preRegionCode + '_full.json'
      }

      this.getGeoJson(regParma).then(
        regionGeoJson => {
          this.initEcharts(preRegionCode, regionGeoJson, preGeoName, this.mapChart, alladcode)
        }
      )
    },
    callMapData(adcode) {
      // The data of show
      let mapData = []

      let geoInit = cityGeo[adcode.toString()]

      for (const key in geoInit) {
        if (Object.hasOwnProperty.call(geoInit, key)) {
          mapData.push({
            name: `${key}节点`,
            value: geoInit[key],
            symbolSize: 10
          })
        }
      }

      // console.log(mapData)
      return mapData
    },
    async initChart() {
      let chart = echarts.init(document.querySelector('.container-map'))
      mapChart = chart
      let alladcode = await this.getGeoJson('all.json')
      let YunNanGeoJson = await this.getGeoJson('530000_full.json')
      this.initEcharts('530000', YunNanGeoJson, '云南省', chart, alladcode)
    },
  }
}
</script>

<style lang="scss">
@import '@/assets/css/init-css.scss';

$area-radius: 25px;
$area-padding: .1rem;
$area-margin: .2rem;

.node-section-page {
  // color: $font-color;
  .banner {
    font-weight: bold;
    position: absolute;
    z-index: 1000;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    .el-button {
      padding: 4px 12px;
      margin-left: 2px;
    }
    .el-button--primary {
      background: $theme-color;
      border-color: $theme-color;
    }
  }

  .el-table {
    background: none;
  }

  .content-three {
    flex: 1;
  }

  // .content-one,.content-two,.content-three, .content-four {
  //   background: $area-background;
  //   border-radius: $area-radius;
  //   padding: $area-padding;
  // }

  //---------置中样式
  &.section-center {
    .banner {
      font-size: .25rem;
    }

    .content-wrapper-one {
      display: flex;
      height: 65%;
      .content-one {
        // padding-top: 5%;
        height: 100%;
        width: 100%;
      }

      .content-two {
        margin-left: $area-margin;
        display: none;
      }
    }

    .content-wrapper-two {
      display: flex;
      padding-top: $area-margin;
      box-sizing: border-box;
      height: 34%;

      .content-three {
        border-radius: 10px;
        overflow: hidden;
        width: 100%;
        height: 100%;
        .el-table td, .el-table th {
          padding: 9px 0;
        }
        .table-button-box {
          margin-top: .15rem;
          display: flex;
          justify-content: flex-end;
          .el-button {
            width: 1.5rem;
            // color: #fff;
            border: none;
            background: #14142e;
            &:last-child{
              margin-left: .2rem
            }
          }
        }
      }

      .content-four {
        margin-left: $area-margin;
        flex: 1;
      }
    }
  }

  //-------------左上样式

  &.section-left {
    border-radius: $area-radius;
    background: $area-background;
    padding: .2rem .4rem;
    box-sizing: border-box;
    .banner {
      display: none;
    }

    .content-wrapper-one {
      display: flex;
      height: 100%;
      .content-one {
        display: none;
      }
    }

    .content-wrapper-two {
      display: none;
    }

  }

  //--------------左下右下样式
  &.section-bottom-left, &.section-bottom-right {
    display: flex;
    border-radius: $area-radius;
    background: $area-background;
    padding: .2rem .3rem;
    box-sizing: border-box;
    .banner {
      display: none;
    }

    .content-wrapper-one {
      display: flex;
      flex: 1;
      .content-one {
        display: none;
      }
    }

    .content-wrapper-two {
      display: none;
    }
  }

   &.section-bottom-left, &.section-bottom-right, &.section-left {
     .content-two {
        flex: 1;
        display: flex;
        flex-direction: column;
        .label {
          margin-bottom: 10px;
          font-weight: bold;
          font-size: .25rem;
          text-align: left;
        }
        .inner-box {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          overflow: auto;
          .icon-item {
            display: flex;
            min-width: 122px;
            align-items: flex-start;
            margin-bottom: 10px;
            .icon {
              margin-right: 10px;
            }
            .text {
              margin-top: .1rem;
              font-size: .16rem;
              color: $theme-font-color;
              text-align: left;
            }
          }
        }
      }
   }

}

</style>
